import React, { useEffect, useMemo, useState } from "react";
import { fetchProfile, getAbout, getUserDetailFromEmail } from "./util";
import { Ptag } from "../../../components/fonts";
import { OverlayLoader } from "../../../components";
import { DisabledInput, SecondaryBtn } from "./style";
import { useHistory } from "react-router-dom";

function MyProfile() {
  const [companyProfile, setCompanyProfile] = useState();
  const [loading, setLoading] = useState(true);

  const history = useHistory();

  const email = useMemo(() => {
    const about = getAbout();
    if (about && about.email) return about.email;
  });

  const currentUserDetails = useMemo(() => {
    if (companyProfile && email) {
      const user = getUserDetailFromEmail(email, companyProfile);
      return user;
    }
  }, [companyProfile]);

  const goToResetPassword = () => {
    history.push("/business/my-profile/reset");
  };

  useEffect(() => {
    (async function() {
      const profile = await fetchProfile();
      if (profile) setCompanyProfile(profile);
      setLoading(false);
    })();
  }, []);

  const renderField = (label, value) => {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <Ptag fontSize="16px" marginBottom="10px">
          {label}
        </Ptag>
        <DisabledInput>
          <Ptag fontSize="16px" color="#231A3D">
            {value}
          </Ptag>
        </DisabledInput>
      </div>
    );
  };

  return loading ? (
    <OverlayLoader />
  ) : (
    <div style={{ background: "white", padding: "4rem" }}>
      <div style={{ maxWidth: "1000px" }}>
        <Ptag
          fontSize="24px"
          fontWeight="700"
          style={{ paddingBottom: "36px" }}
        >
          My Profile
        </Ptag>
        <div
          style={{
            marginBottom: "2rem",
          }}
        >
          {currentUserDetails.name &&
            renderField("Name", currentUserDetails.name)}
        </div>
        <section
          style={{
            display: "flex",
            gap: "2rem",
          }}
        >
          {renderField("Email", email)}
          {currentUserDetails.phone &&
            renderField("Mobile", currentUserDetails.phone)}
        </section>

        <footer
          style={{
            marginTop: "44px",
          }}
        >
          <SecondaryBtn onClick={goToResetPassword}>
            Change Password
          </SecondaryBtn>
        </footer>
      </div>
    </div>
  );
}

export default MyProfile;
